import { render, staticRenderFns } from "./UpgradePromptPage.vue?vue&type=template&id=38846058&scoped=true"
import script from "./UpgradePromptPage.vue?vue&type=script&lang=js"
export * from "./UpgradePromptPage.vue?vue&type=script&lang=js"
import style0 from "./UpgradePromptPage.vue?vue&type=style&index=0&id=38846058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38846058",
  null
  
)

export default component.exports